const landingImages = document.querySelectorAll('.landing-module__illustration-image');

if (landingImages.length) {
  landingImages.forEach((image, index) => {
    const moveY = [0, 2, 4, 5, 7].includes(index) ? '-50%' : '150%';

    gsap.to(image, {
      y: moveY,
      ease: 'linear',
      scrollTrigger: {
        trigger: '.landing-module',
        start: 'top top',
        end: 'bottom top',
        scrub: 3,
      },
    });
  });
}
